import { render } from "./CampaignLayout.vue?vue&type=template&id=2e2e5908&scoped=true"
import script from "./CampaignLayout.vue?vue&type=script&lang=js"
export * from "./CampaignLayout.vue?vue&type=script&lang=js"

import "./CampaignLayout.vue?vue&type=style&index=0&id=2e2e5908&scoped=true&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2e5908"]])

export default __exports__